import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: process.env.VITE_API_ENV === 'dev' ? 0 : 3,
      retryDelay: 1000,
      // would refresh unless polling or invalidate
      staleTime: Infinity,
      // cache the data forever
      gcTime: Infinity,
      refetchOnWindowFocus: false,
    },
  },
});
